
import Vue from 'vue'
import Component from 'vue-class-component'
// import { Mutation, namespace, State } from 'vuex-class'

@Component
export default class Footer extends Vue {
}
